import React, { useState } from 'react';
import Axios from 'axios';
import Swal from 'sweetalert2';
import EditTourDetailsModalContainer from './EditTourDetailsModalContainer';

function VirtualTourDetailsHeader({
  virtualTour,
  $location,
  setVirtualTour,
  $rootScope,
  retsId,
  dashboardId,
  isMyBusiness,
  virtualShowingDomain,
  isCancelled,
  setIsCancelled,
}) {
  const DEFAULT_VIRTUAL_SHOWING_DOMAIN =
    virtualShowingDomain || 'https://edge.brokerbay.com/virtual_showing/';

  const isExternal = retsId || dashboardId;
  const [modalVisible, setModalVisible] = useState(false);

  const link = `${DEFAULT_VIRTUAL_SHOWING_DOMAIN}${virtualTour.room}`;

  const onOpenEditModal = () => {
    setModalVisible(true);
  };

  const onCancel = () => {
    setModalVisible(false);
  };

  const back = () => {
    const path = isMyBusiness
      ? '/my_business'
      : $location.path().replace(
          `tour/${virtualTour.id}/details`,
          // External link is `book`, internal link is `appointments/book`
          isExternal ? `book` : `appointments/book`,
        );
    $rootScope.$apply(() => {
      $location.path(path);
    });
  };

  const onCancelTour = async () => {
    const { value } = await Swal.fire({
      title: 'Cancel Tour',
      text: 'Click "Confirm" to cancel tour',
      type: 'error',
      cancelButtonColor: '#3085d6',
      confirmButtonColor: '#d33',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });
    if (value) {
      await Axios.post(
        isExternal
          ? `/external/virtual_tour/${virtualTour.id}/cancel`
          : `/virtual_tour/${virtualTour.id}/cancel`,
        {
          retsId,
          dashboardId,
        },
      );
      setIsCancelled(true);
      if (isExternal || !isMyBusiness) back();
    }
  };

  return (
    <div className="normalheader transition animated fadeIn">
      <div className="hpanel">
        <div
          className="panel-body"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h3
            style={{ width: '100%' }}
            className="font-light m-b-xs p-x-none col-xs-12 col-lg-9"
          >
            3D Virtual Tour <span className="hidden-xs">Conference</span>
          </h3>

          <div
            style={{
              display: 'flex',
              paddingLeft: '5px',
            }}
          >
            {isCancelled ? (
              <button className="btn btn-default margin-right" onClick={back}>
                Back
              </button>
            ) : (
              <>
                <button
                  onClick={onCancelTour}
                  className="btn btn-danger margin-right"
                  data-cy="cancel-tour-button"
                >
                  Cancel <span className="hidden-xs">Tour</span>
                </button>

                <button
                  className="btn btn-default margin-right"
                  onClick={onOpenEditModal}
                  data-cy="edit-tour-button"
                >
                  Edit <span className="hidden-xs">Tour Details</span>
                </button>
                <EditTourDetailsModalContainer
                  modalVisible={modalVisible}
                  onCancel={onCancel}
                  virtualTour={virtualTour}
                  setVirtualTour={setVirtualTour}
                  retsId={retsId}
                  dashboardId={dashboardId}
                />
                <a
                  className="btn btn-primary"
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-cy="start-tour-button"
                >
                  Start <span className="hidden-xs">Tour</span>
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VirtualTourDetailsHeader;
